export class WebCardModel {

}

export class RateAndReviewModel {
    BusinessName: string = "";
    OverallRatingText: string = "";
    StarHeaderText: string = "";
    StarText: string = "";
    StarImageUrl: string = "";
    UserReviewText: string = "";
  SubmittedRNR: boolean = false;
  ReviewerName: string = '';
  ReviewerEmailID: string = '';
  ReviewerMobile: string = '';
  BusinessBranchID: string = '';
}

export class ClickToCallModel {
    IsSubmitted: boolean = false;
    BusinessName: string = "";
    AcceptTerms: boolean = false;
}

export class ReportBizModel {
    IsSubmitted: boolean = false;
    BusinessName: string = "";
}

export class GrabADealModel {
    IsSubmitted: boolean = false;
}

export interface IRateAndReview {
    ID: number;
    IsSelected: string;
}

export interface IDropDownList {
    DataText: string;
    DataValue: string;
}
